import { useQuery } from "@tanstack/react-query";
import type { SellerActivityStatisticsParams } from "./statisticsApi";
import { getSellerActivityStatistics } from "./statisticsApi";

export function useSellerActivityStatistics(
  sellerIds: string[],
  params: Omit<SellerActivityStatisticsParams, "sellerIds">,
) {
  const fullParams: SellerActivityStatisticsParams = {
    ...params,
    sellerIds: sellerIds.length === 0 ? "all" : sellerIds,
  };
  return useQuery({
    queryKey: ["admin", "statistics", "sellers", "activity", fullParams],
    queryFn: ({ signal }) => getSellerActivityStatistics(fullParams, signal),
    enabled: sellerIds.length > 0 && Boolean(params.from && params.to),
  });
}
